import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiServiceService} from '../api-service.service';
import {Keys, StorageService} from '../service/storage.service';
import {Component, Input, OnInit, SimpleChanges} from '@angular/core';

@Component({
    selector: 'app-theader',
    templateUrl: './theader.component.html',
    styleUrls: ['./theader.component.css'],
    providers: [ApiServiceService]
})

export class TheaderComponent implements OnInit {

    result: any;
    name: string;
    dashLink: any;
    loandetails: any;
    user_type: string;
    opacity = 1;
    @Input() partnerImg;
    partnerImage: string;
    faqLink = true;
    loggedIn = false;
    borrowTab = false;
    notLoggedIn = true;
    loan_application_status: any;
    loanApplication = false;
    borrowerDashboard = false;

    constructor(private route: ActivatedRoute, private router: Router, private ref: ApiServiceService, private storageService: StorageService,
                public dialog: MatDialog) {
    }

    logout() {
        this.storageService.clear();
        this.notLoggedIn = true;
        this.loggedIn = false;
        this.router.navigate(['/login']);
    }

    goToLink(link) {
        this.router.navigate(['../' + link]);
    }

    ngOnChanges(changes: SimpleChanges) {
        this.partnerImage = this.storageService.getItem(Keys.PARTNER_IMAGE);
    }

    ngOnInit() {
        const name = this.storageService.getItem(Keys.NAME);
        const token = this.storageService.getItem(Keys.TOKEN);
        const profileId = this.storageService.getItem(Keys.PROFILE_ID);

        if (this.router.isActive('/borrow', true)) {
            this.router.navigate(['/intro']);
        } else if (this.route.snapshot.url[0].path == 'intro') {
            this.opacity = 0.5;
            this.faqLink = true;
            this.loanApplication = true;
            if (profileId == null || profileId == '' || profileId == undefined) {
                this.notLoggedIn = true;
            } else {
                this.notLoggedIn = false;
            }
        } else if (this.route.snapshot.url[0].path == 'loaninfo' || this.route.snapshot.url[0].path == 'pan-verification' || this.route.snapshot.url[0].path == 'phone-verification') {
            this.opacity = 0.5;
            this.faqLink = true;
            this.loanApplication = true;
            this.notLoggedIn = false;
        }
    }

}
